//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CurrencyService } from "@nuskin/ns-shop";
import { RunConfigService } from "@nuskin/ns-util";

export default {
  name: "NsCurrency",
  props: {
    /**
     * The currency amount to display
     */
    amount: {
      type: [Number, String],
      required: true
    },
    /**
     * The priceType of the amount displayed
     */
    priceType: {
      type: String,
      default: ""
    },
    /**
     * Set to block display of currency until ready
     */
    loading: Boolean,
    /**
     * Strike out the currency amount
     */
    strikeThrough: Boolean
  },
  computed: {
    formattedCurrency() {
      let runConfig = RunConfigService.getRunConfig();
      return CurrencyService.format(
        this.amount,
        runConfig.country,
        runConfig.language
      );
    }
  }
};
